import { render, staticRenderFns } from "./Purple-gradient.vue?vue&type=template&id=58a88e87"
import script from "./Purple-gradient.vue?vue&type=script&lang=js"
export * from "./Purple-gradient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports